export const USER_SERVER = process.env.REMO_USER_SERVER_DOMAIN;
export const FILE_SERVER = process.env.REMO_FILE_SERVER_DOMAIN;
export const CHANNEL_SERVER = process.env.REMO_CHANNEL_SERVER_DOMAIN;

export const REMO_AGREEMENT_URL = process.env.REMO_AGREEMENT_URL;
export const REMO_GAME_WEB_URL = process.env.REMO_WEB_DOMAIN;
